import { IOrganizationOutputDto } from './organization-output.interface';
import { TypologiesEnum } from '../../../../../shared/auth-system/src';

export interface IUserOutputDto {
    id: string;
    /** @deprecated */
    externalId: string; // deprecated
    email: string;
    firstName: string;
    lastName: string;
    locale?: string;
    phone?: string;
    avatar?: string;
    settings?: Record<string, unknown>;
    address?: string;
    organizations?: IOrganizationOutputDto[];
    userOrganizations?: IUserOrganizationsOutputDto[];
    currentOrganization: string;
    /** @deprecated */
    permissions?: IPermissionsOutputDto[]; // deprecated
    /** @deprecated */
    roles?: IRoleOutputDto[]; // deprecated
    applications?: IApplicationsOutputDto[];
    applicationModules?: IApplicationModulesOutputDto[];
    /** @deprecated */
    typology?: ITypologyOutputDto; // deprecated
    hashedRefreshToken?: string;
    disabled?: boolean;
    disabledReason?: string;
    verifyingEmail?: IVerifyingEmailOutputDto;
    verifyingPhone?: IVerifyingPhoneNumberOutputDto;
}

export interface IApplicationModulesOutputDto {
    application: IApplicationsOutputDto | string;
    modules: string[];
}

export interface ITypologyOutputDto {
    id: string;
    code: TypologiesEnum;
    name: string;
}

export interface IVerifyingEmailOutputDto {
    email: string;
    timestamp: string;
}

export interface IVerifyingPhoneNumberOutputDto {
    phone: string;
    timestamp: string;
}

export interface IUserOrganizationsOutputDto {
    organization: string;
    roles: IRoleOutputDto[];
    externalId?: string;
    typology: ITypologyOutputDto;
    applications: IApplicationsOutputDto[];
    applicationModules?: (IApplicationModulesOutputDto & { application: string })[];
}

export interface IPermissionsOutputDto {
    id: string;
    name: string;
    code: string;
}

export interface IRoleOutputDto {
    id?: string;
    name: string;
    permissions: IPermissionsOutputDto[];
}

export interface IApplicationsOutputDto {
    id: string;
    name: string;
    description: string;
    modules: string[];
}

export interface IUpdateOrganizationUserPayload {
    applications?: string[];
    roles?: string[];
}
